import { Controller } from "@hotwired/stimulus"

// Opens and closes the navigation menu on small screens.
// Connects to data-controller="menu"
export default class extends Controller {
  static targets = ["button", "panel"]

  toggle() {
    const hidden = this.panelTarget.classList.toggle("hidden")
    this.buttonTarget.setAttribute("aria-expanded", hidden ? "false" : "true")
  }
}
